class FostrTabsMenu extends HTMLElement {
  constructor () {
    super()
    this.openFirstTab()
    this.querySelectorAll('details').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    )
    this.details = this.querySelectorAll('details')
    this.setHeights()
  }

  openOneOnly () {
    this.details.forEach(deet => {
      if (this !== deet && deet.open) {
        deet.open = false
      }
    })
  }

  onButtonClick (event) {
    this.openOneOnly()
  }

  openFirstTab () {
    this.querySelector('details').open = true
  }

  setHeights () {
    this.details.forEach(deet => {
      const contentHeight = deet.querySelector('div')
      // deet.open = true
      contentHeight.style.height = `${contentHeight.clientHeight}px`
      // deet.open = false;
    })
  }
}

customElements.define('fostr-tabs-menu', FostrTabsMenu)
